import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom';
import { Row, Col, Container, Input, Table } from 'reactstrap';
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//constant
import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { useNavigate } from 'react-router-dom'
import { requestApi } from '../../../request-api';

function AuditorTable() {

    let [isChecked, setIsChecked] = useState(false);
    let [auditor,setAuditor] = useState([])
    let [select,setSelect] = useState(0)
    let [filterValue,setFilterValue] = useState([])
    let [auditorFilter, setAuditorFilter] = useState([]); 

    const [search , setSearch] = useState('');
    useEffect(()=>{
        requestApi('/superadmin/auditor',{
            method: 'get',

        }).then((data)=>{
            setAuditorFilter(data.data)
            setSelect(0)
            setAuditor(data.data)
            setFilterValue(data.data)
            
        }).catch((error)=>{
            console.log(error)
        })
    },[select])

    useEffect(()=>{
        if(search === 'empty'){
          
            return setAuditorFilter(auditor)
        }
        console.log("searcg result ",search)
      const result = auditor.filter(audi =>{
        return audi.name.toLowerCase().match(search.toLowerCase()) ||
        audi.email.toLowerCase().match(search.toLowerCase()) ||
        audi.phone_number.toLowerCase().match(search.toLowerCase()) 
      })
    
      setAuditorFilter(result)
    },[search])
    
    const navigate = useNavigate()
    const handleButton = () =>{
        navigate(`${directUrl}super-admin/create-auditor`)
    }
    const [startDate, setStartDate] = useState(new Date());
    const filterByName =(selected) =>{
        console.log("---->",selected)
        if(selected == 'Select'){
            setSelect(1)
        }else{
        let auditorFilter = auditor.filter((au)=>{return selected === au.name})
        setAuditor(auditorFilter)
        }
    }
   
    const handleOnChange = () => {
        setIsChecked(!isChecked);
      };

    
    let srNo = 0
      


  return (
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
            <div className='bs-card'>
                <Row>
                    {isChecked ? (
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            {/* <div className='bs-action-btn'>
                                <div className='button-group'>
                                <a className='action-btn' href=""> <span className="icon icon-download"></span></a>
                                <a className='action-btn' href=""> <span className="icon icon-share"></span></a>
                                <a className='action-btn' href=""><span className="icon icon-delete"></span></a>
                                </div>
                            </div>      */}
                        </Col>  
                        ) :  (
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className='bs-table'>
                                <div className='main-header'>
                                    <form className='bs-form'>
                                        <div className='search-btn'>
                                            <Input type='text' placeholder='Search...' className='no-min-height'  onChange={(e) => {
                              setSearch(e.target.value);
                            }}/>
                                            <i className='icon icon-search'></i>
                                        </div>
                                        <div className='dropdown-bx'>
                                            <label className='form-label'>Auditor Name :  </label>
                                            <Input  type="select" name="select" id="exampleSelect" onChange={(e) => {
                                            setSearch(e.target.value);
                                            }}  >
                                            <option value={'empty'}>Select</option>
                                            {filterValue.map((auditorData)=>{
                                                return(
                                                    <option key={auditorData.name} value={auditorData.name}>{auditorData.name}</option>
                                                )
                                            })}
                                               
                                              
                                            </Input>
                                        </div>
                                    </form>
                                    <div className='left-button'>
                                    <button className='bs-btn typ-white' onClick={handleButton} ><span className="icon icon-plus"></span> create auditor</button>
                                    </div>
                                </div>
                            </div>     
                        </Col> 
                    )}
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <div className='bs-table typ-datatable'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        {/* <th><Input type="checkbox" />{' '}</th> */}
                                        <th>Sr.No.</th>
                                        <th>Auditor’s  <span className='d-block'>Name</span></th>
                                        <th>Email ID</th>
                                        <th>Contact Number</th>
                                    </tr>
                                </thead>
                              {auditor.forEach((m)=>{console.log(m)})}
                                <tbody>
                                     {auditorFilter.map((auditorData)=>{
                                        srNo+=1
                                        return(
                                        
                                        <tr>
                                        {/* <td><Input type="checkbox" checked={isChecked} onChange={handleOnChange} />{' '}</td> */}
                                        <td>{srNo}</td>
                                        <td>{auditorData.name}</td>
                                        <td>{auditorData.email}</td>
                                        <td>{auditorData.phone_number}</td>
                                       
                                    </tr>
                                   
                                     )})}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </Row>
            </div>    
        </Container>
    </section>
  )
}

export default AuditorTable
